<mat-card class="content-card">

  <h3>Financial Dashboard</h3>

  <h4>Filters</h4>

  <div fxLayout="row" style="">

    <div fxFlex="100">
      <form [formGroup]="financialStatsForm" (ngSubmit)="submit()">
        <mat-form-field>
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="picker2" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <!--<mat-form-field>
          <mat-label>Grouping</mat-label>
          <mat-select formControlName="grouping">
            <mat-option *ngFor="let group of [{key: 0, name: 'None'}, {key: 1, name: 'Country'}, {key: 3, name: 'City'}, {key: 4, name: 'Age'}, {key: 7, name: 'Order source'}]"
                        [value]="group.key">
              {{group.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>-->

        <!--<mat-form-field>
          <mat-label>Interval</mat-label>
          <mat-select formControlName="interval">
            <mat-option *ngFor="let interval of [{key: 1, name: 'Day'}, {key: 2, name: 'Week'}, {key: 3, name: 'Month'}, {key: 4, name: 'Quarter'}, {key: 5, name: 'Year'}]"
                        [value]="interval.key">
              {{interval.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>-->

        <button [disabled]="isLoadingOrders || isLoadingLoads" style="margin-left: 10px;" mat-raised-button color="primary" type="submit">
          Submit
        </button>

        <button mat-raised-button [disabled]="isLoadingOrders || isLoadingLoads" style="margin-left: 10px; margin-right: 5px;" type="button"
                (click)="goToPreviousPeriod()">Previous
        </button>
        <button mat-raised-button [disabled]="isLoadingOrders || isLoadingLoads" type="button" (click)="goToNextPeriod()">Next</button>

      </form>
    </div>
  </div>

  <div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="filters">

    <mat-form-field class="country-filter-field">
      <mat-select placeholder="Country filters" [(ngModel)]="selectedCountries" multiple>
        <mat-option *ngFor="let country of countries" [value]="country">{{country.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="brand-filter-field" *ngIf="!currentUserIsPartner()">
      <mat-select placeholder="Brand filters" [(ngModel)]="selectedCompanies" (ngModelChange)="companyChanged()"
                  multiple>
        <mat-option *ngFor="let company of companies" [value]="company">{{company.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="product-filter-field" *ngIf="!currentUserIsPartner()">
      <mat-select placeholder="Product filters" [(ngModel)]="selectedProducts" multiple>
        <mat-option *ngFor="let product of products" [value]="product">{{product.internalName}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="platform-filter-field">
      <mat-select placeholder="Platform filters" [(ngModel)]="selectedPlatform">
        <mat-option [value]="-1">All</mat-option>
        <mat-option [value]="0">Unknown</mat-option>
        <mat-option [value]="1">iOS</mat-option>
        <mat-option [value]="2">Android</mat-option>
      </mat-select>
    </mat-form-field>


  </div>


  <h4>Cashback</h4>

  <div>
    <div style="font-size: .8em; color: cornflowerblue;">* Only Cashbacks of the selected period, which are not yet paid out</div>
  </div>



    <mat-progress-bar *ngIf="isLoadingTotals" mode="indeterminate"></mat-progress-bar>

    <div>

      <div class="amount-box">
        <div style="font-size: .9em;">Cashback Given</div>
        <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 2em;">{{totals.cashbackGiven | number: '1.2-2'}}</div>
        <div style="font-size: .8em;">Cashback granted to cardholders</div>
      </div>

      <div class="amount-box">
        <div style="font-size: .9em;">Cashback Liabilities</div>
        <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 2em;">{{totals.cashbackLiabilities | number: '1.2-2':'de'}} <span style="color: cornflowerblue;">*</span></div>
        <div style="font-size: .8em;">Cashback not paid out yet</div>
      </div>

      <div class="amount-box">
        <div style="font-size: .9em;">Cashback Paid Out</div>
        <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 2em;">{{totals.cashbackPaid | number: '1.2-2'}}</div>
        <div style="font-size: .8em;">Cashback paid to cardholders</div>
      </div>

      <button mat-raised-button color="primary" routerLink="../cashback">More...</button>

  </div>


  <h4>Annual Fees</h4>

  <mat-progress-bar *ngIf="isLoadingTotals" mode="indeterminate"></mat-progress-bar>

  <div>

    <div class="amount-box">
      <div style="font-size: .9em;">Annual Fees deducted</div>
      <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 1.5em;">Count: {{totals.annualFeeDeducted.number | number: '1.0-0':'de' }}<br />Volume: {{totals.annualFeeDeducted.volume | number: '1.2-2' }}</div>
      <div style="font-size: .8em;">Deduction from card balance</div>
    </div>

    <div class="amount-box">
      <div style="font-size: .9em;">Annual Fees Invoiced</div>
      <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 1.5em;">Count: {{totals.annualFeeInvoiced.number | number: '1.0-0':'de' }}</div>
      <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 1.5em;">Volume: {{totals.annualFeeInvoiced.volume | number: '1.2-2':'de' }}</div>
      <div style="font-size: .8em;">Invoiced to card holder</div>
    </div>


    <div class="amount-box">
      <div style="font-size: .9em;">Annual Fees Invoice payment</div>
      <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 1.5em;">Count: {{totals.annualFeePaid.number | number: '1.0-0':'de' }}</div>
      <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 1.5em;">Volume: {{totals.annualFeePaid.volume | number: '1.2-2':'de' }}</div>
      <div style="font-size: .8em;">Invoice payments</div>
    </div>


    <button mat-raised-button color="primary" routerLink="../annual-fee">More...</button>

  </div>


  <h4>Transactions</h4>

  <mat-progress-bar *ngIf="isLoadingTotals" mode="indeterminate"></mat-progress-bar>

  <div>

    <div class="amount-box">
      <div style="font-size: .9em;">POS / Online</div>
      <div *ngIf="totals" style="display: block; margin: 0; padding: 0; font-family: monospace; font-weight: bold; font-size: 1.5em;">Count: {{totals.txnPosOnline.number | number: '1.0-0':'de' }}</div>
      <div *ngIf="totals" style="display: block; margin: 0; padding: 0; font-family: monospace; font-weight: bold; font-size: 1.5em;">Volume: {{totals.txnPosOnline.volume | number: '1.2-2':'de' }}</div>
    </div>

    <div class="amount-box">
      <div style="font-size: .9em;">ATM withdrawal</div>
      <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 1.5em;">Count: {{totals.txnAtmWithdrawal.number | number: '1.0-0':'de' }}</div>
      <div *ngIf="totals" style="font-family: monospace; font-weight: bold; font-size: 1.5em;">Volume: {{totals.txnAtmWithdrawal.volume | number: '1.2-2':'de' }}</div>
    </div>

    <button mat-raised-button color="primary" routerLink="../transactions">More...</button>


  </div>

</mat-card>


